import request from '@/utils/request'

export function findSimCardMonthCosts(params) {
  return request({
    url: `/sim_card_month_costs`,
    method: 'get',
    params
  })
}

export function findSimCardMonthCostDetail(id) {
  return request({
    url: `/sim_card_month_costs/${id}`,
    method: 'get'
  })
}

export function rerunSimCardMonthCost(data) {
  return request({
    url: `/sim_card_month_costs/rerun`,
    method: 'post',
    data
  })
}
